export default __webpack_public_path__ + "static/media/Icon material-info-outline.2f66ebf4.svg";